export enum ClientCapability {  
  MANAGE_PROJECTS = "MANAGE_PROJECTS",
  MANAGE_PROJECT_MANAGEMENT_SETTINGS = "MANAGE_PROJECT_MANAGEMENT_SETTINGS",
  MANAGE_HY_DRY_DEVICES = "MANAGE_HY_DRY_DEVICES",
  MANAGE_ALL_DEVICES = "MANAGE_ALL_DEVICES",
  MANAGE_MESSAGES = "MANAGE_MESSAGES",
  MANAGE_HY_DRY_MESSAGES_SETTINGS = "MANAGE_HY_DRY_MESSAGES_SETTINGS",

  MANAGE_USERS = "MANAGE_USERS",
  MANAGE_TIME_TRACKING = "MANAGE_TIME_TRACKING",
  MANAGE_SCHEDULING = "MANAGE_SCHEDULING",
  MANAGE_VEHICLES = "MANAGE_VEHICLES",
  MANAGE_DEVICES_CHECK = "MANAGE_DEVICES_CHECK",
  MANAGE_ROLES = "MANAGE_ROLES",
  MANAGE_BRANCHES = "MANAGE_BRANCHES",
  MANAGE_GEO_ENCODING = "MANAGE_GEO_ENCODING",

  VIEW_TEST_HY_DRY_DEVICES = "VIEW_TEST_HY_DRY_DEVICES",
  VIEW_IRES_INFO = "VIEW_IRES_INFO",
  VIEW_ADDITIONAL_PAUSE_DURATION_OPTIONS = "VIEW_ADDITIONAL_PAUSE_DURATION_OPTIONS",
  ALWAYS_SHOW_HY_DRY_DEVICE_STATUS = "ALWAYS_SHOW_HY_DRY_DEVICE_STATUS",
  CURRENT_STATUS_ALWAYS_VISIBLE_TO_USER = "CURRENT_STATUS_ALWAYS_VISIBLE_TO_USER",

  VIEW_PROGRAM_CHAINS_OF_ALL_CLIENTS = "VIEW_PROGRAM_CHAINS_OF_ALL_CLIENTS",
  VIEW_PROGRAM_CHAINS_WITH_UNDEFINED_PROGRAM_NUMBER = "VIEW_PROGRAM_CHAINS_WITH_UNDEFINED_PROGRAM_NUMBER",
  
  CONFIGURE_ADMINISTRATION_CAPABILITIES = "CONFIGURE_ADMINISTRATION_CAPABILITIES",
  CONFIGURE_ADMINISTRATION_SETTINGS = "CONFIGURE_ADMINISTRATION_SETTINGS",

  CLIENT_ADMINISTRATION = "CLIENT_ADMINISTRATION",
  DEVICE_ADMINISTRATION = "DEVICE_ADMINISTRATION",
  SETTINGS_ADMINISTRATION = "SETTINGS_ADMINISTRATION",
  USER_ADMINISTRATION = "USER_ADMINISTRATION",
  LICENCE_ADMINISTRATION = "LICENCE_ADMINISTRATION",

  DEFINE_CATEGORIES_AND_TEMPLATES = "DEFINE_CATEGORIES_AND_TEMPLATES",
  DEFINE_OWN_ROLE_SETTINGS = "DEFINE_OWN_ROLE_SETTINGS",
  DEFINE_SYSTEM_CONFIGURATION = "DEFINE_SYSTEM_CONFIGURATION",
  DEFINE_OWN_REPORT_SETTINGS = "DEFINE_OWN_REPORT_SETTINGS",
  DEFINE_REPORT_SETTINGS_FOR_GROUP = "DEFINE_REPORT_SETTINGS_FOR_GROUP",
  DEFINE_OWN_USER_SETTINGS = "DEFINE_OWN_USER_SETTINGS",
  DEFINE_OWN_COMPANY_SETTINGS = "DEFINE_OWN_COMPANY_SETTINGS",
  DEFINE_OWN_HY_DRY_DEVICE_SETTINGS = "DEFINE_OWN_HY_DRY_DEVICE_SETTINGS",
  DEFINE_OWN_PROJECT_MANAGEMENT_SETTINGS = "DEFINE_OWN_PROJECT_MANAGEMENT_SETTINGS",
  DEFINE_PROJECT_MANAGEMENT_SETTINGS_FOR_GROUP = "DEFINE_PROJECT_MANAGEMENT_SETTINGS_FOR_GROUP",
  DEFINE_OWN_ALL_DEVICES_SETTINGS = "DEFINE_OWN_ALL_DEVICES_SETTINGS",
  DEFINE_OWN_HY_DRY_MESSAGE_SETTINGS = "DEFINE_OWN_HY_DRY_MESSAGE_SETTINGS",

  DEFINE_FINISHED_PROJECTS_SETTINGS = "DEFINE_FINISHED_PROJECTS_SETTINGS",

  SWITCH_CLIENTS = "SWITCH_CLIENTS",

  VIEW_ADMINISTRATOR_CLIENT_SETTINGS = "VIEW_MASTER_SETTINGS",
  VIEW_EXTERNAL_SYSTEM = "VIEW_EXTERNAL_SYSTEM",
}

